import { AxiosError, AxiosResponse } from 'axios';
import { push } from 'redux-first-history';

import { OnResponseRejected } from '@libs/axios/types';

import documentAuthService from '@app/libs/auth/documentAuthService';
import store from '@app/store';

import { isModusignAPI } from '../utils';

const isPathnameThatShouldBeBypassed = (pathname: string): boolean => {
  const pathnameDenylist: RegExp[] = [
    /^\/document/,
    /^\/document-download/,
    /^\/participant$/,
    /^\/signing/,
    /^\/link\/[^/]+\/authentication/,
    /^\/embedded-participant/,
  ];
  return pathnameDenylist.some((expr) => expr.test(pathname));
};

const is403AxiosResponse = (response?: AxiosResponse<unknown>) => response?.status === 403;

const isResponseForModusignApi = (url?: string) => url && isModusignAPI(url);

/**
 * 모두싸인 API에서 HTTP 403 응답을 반환할 때 링크 유저인 경우 로그인 창으로 리다이렉트 하기 위한 interceptor
 */
export const onRejected: OnResponseRejected = (error: AxiosError) => {
  const { config, response } = error;
  if (
    isResponseForModusignApi(config.url) &&
    is403AxiosResponse(response) &&
    documentAuthService.isLinkUser()
  ) {
    if (!isPathnameThatShouldBeBypassed(window.location.pathname)) {
      const { dispatch } = store;
      dispatch(push({ pathname: '/authentication/signin', search: window.location.search }));
    }
  }
  return Promise.reject(error);
};
